import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router";
import {LoginService} from '../login.service';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  private loader=false;
  public error = false;
  public loginRedirect = false;


  constructor(public router:ActivatedRoute, private loginService:LoginService, public toastService:ToastrService, private routerService:Router) { }

  ngOnInit() {   
    console.log('redirect ngOnInit -> getcitizenInfo(token) ');    
    if(this.router != undefined && this.router.params != undefined){
      console.log('this.router.params ' + this.router.params);
    }    
    this.router.params.subscribe((params)=>{
      console.log('params.token' + params.token);
      (params.token === 'transfer') ? this.loginRedirect = true : 
      this.getcitizenInfo(params.token)
    });
  }

  getUserInfo(id){
    console.log('START ============== redirect.component.ts::getUserInfo ID : ' + id);
    this.error = false;
    $(".loader").removeClass('hide');
    this.loginService.getAriesuser(id).subscribe((data)=>{
      if(data !== null && data["id"]){
        console.log('redirect.component load');
        this.loginService.load();
        this.loginService.personId = data["id"];
        console.log(' this.loginService.personId ' + this.loginService.personId);
        console.log('ServerConstantsService.serverConstants.privateKey ' + ServerConstantsService.serverConstants.privateKey);
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        console.log(' key ' + key);
        sessionStorage.setItem('id',CryptoJS.AES.encrypt(data["id"].toString(),key).toString());
        this.loginService.firstName = data["firstName"];
        console.log('this.loginService.firstName ' + this.loginService.firstName);
        sessionStorage.setItem("firstName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        this.loginService.lastName = data["lastName"];
        console.log('this.loginService.lastName ' + this.loginService.lastName);
        sessionStorage.setItem("lastName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
        setTimeout(()=>{          
          sessionStorage.setItem('conversion_stat',CryptoJS.AES.encrypt('true',key).toString());
          this.routerService.navigate(['dashboard']);
          $(".loader").addClass('hide');
        },2000)
      }
      else{
        this.error = true;
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.error = true;
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
    console.log('END ============== redirect.component.ts::getUserInfo ID ');
  }

  getAriesCitizenInfo(value){
    console.log('START ============== redirect.component.ts::getAriesCitizenInfo value : ' + value);
    let request = {
      "type":"clientInfo",
      "value":"0/"+value
    }
    this.loginService.getClietinfoAries(request).subscribe((data:Array<Object>)=>{
      if(data[0]["indvId"]){
        //if(data[0]["BENEFIT"] == null){
          this.getUserInfo(data[0]["indvId"]);
          this.loginService.monthlyBenefit = 0;
        /*}
        else{
          let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
          this.loginService.monthlyBenefit = data[0]["BENEFIT"];
          sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(data[0]["BENEFIT"].toString(),key).toString());
        }*/
        //this.loginService.participationCode = data.find(obj => obj['HH_MEM_RELATIONSHIP'] == 'Self')['HH_MEM_WP'];
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(this.loginService.monthlyBenefit.toString(),key).toString());
        this.loginService.participationCode = "Mandatory - SNAP";
        sessionStorage.setItem('status',CryptoJS.AES.encrypt(this.loginService.participationCode.toString(),key).toString());
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
       
        
      }
      else{
        this.toastService.error("Unable to load User Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Information");
    })
    console.log('END ============== redirect.component.ts::getAriesCitizenInfo value');
  }
  getcitizenInfo(token){
    //$(".loader").removeClass('hide');
    //this.loader = true;
    console.log('START ============== redirect.component.ts::getcitizenInfo token : ' + token);
    this.loginService.decodeToken(token).subscribe((data:Array<Object>)=>{
      this.loader = false;
      if(data["preferred_username"]){
        this.getAriesCitizenInfo(data["preferred_username"]);
      }
      else{
        this.error = true;
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.error = true;
      setTimeout(()=>{
        $(".loader").addClass('hide');
    },1000)
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
    console.log('END ============== redirect.component.ts::getcitizenInfo');
  }

  navigate(){
    window.location.replace(ServerConstantsService.serverConstants.ariesUrl);
  }

  redirectHelp(){
    window.location.replace(window.location.origin+"/help");
  }

}



// WEBPACK FOOTER //
// ./src/app/redirect/redirect.component.ts